import React from 'react';

import { Icon } from '../icons';

export const ErrorTextIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 14 14" stroke={color} style={style} fill="none">
      <g>
        <path
          d="M2.1875 3.0625H1.3125V6.125H7.875V3.0625H7.21875"
          strokeWidth="0.65625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="10.0625" y="3.0625" width="2.625" height="3.0625" strokeWidth="0.65625" strokeLinejoin="round" />
        <rect x="1.3125" y="8.3125" width="3.9375" height="3.0625" strokeWidth="0.65625" strokeLinejoin="round" />
        <rect x="7.4375" y="8.3125" width="5.25" height="3.0625" strokeWidth="0.65625" strokeLinejoin="round" />
        <path d="M3.5 4.59375L5.90625 1.75" strokeWidth="0.65625" strokeLinecap="round" />
        <path d="M5.90625 4.59375L3.5 1.75" strokeWidth="0.65625" strokeLinecap="round" />
      </g>
    </svg>
  );
};
